import { Typography } from 'antd';

export type JobNameRendererProps = {
  name: string;
  showTailNameOnly?: boolean;
};

export const JobNameRenderer = ({ name, showTailNameOnly = false }: JobNameRendererProps) => {
  const parts = name.split('.');

  if (parts.length !== 3) return name;

  if (showTailNameOnly) {
    return <div title={name}>{parts[2]}</div>;
  }

  return (
    <>
      <Typography.Text type="secondary">
        {parts[0]}.{parts[1]}.
      </Typography.Text>
      <strong>{parts[2]}</strong>
    </>
  );
};
